import { axiosPrivate, getLocale } from ".";
import store from "../store";

export const getCheckInFlow = productId =>
  axiosPrivate.post(
    `checkin/fluxo_checkin`,
    {
      loja: store.getters.storeSequencial,
      idproduto: productId,
    },
    {
      cache: true,
    }
  );

export const getCheckInItems = (productId, search) =>
  axiosPrivate.post(
    `checkin/listar`,
    {
      loja: store.getters.storeSequencial,
      idproduto: productId,
      documento: search,
    },
    {
      cache: true,
    }
  );

export const fetchTicketBurn = itemId =>
  axiosPrivate.post(
    `loja/pedido_item/desfazer_queimar_ingresso`,
    {
      loja: store.getters.storeSequencial,
      iditem: itemId,
    },
    {
      cache: true,
    }
  );

export const fetchValidateTicket = (consumerId, media) =>
  axiosPrivate.post(
    "loja/pedido_item/queimar_ingresso",
    {
      loja: store.getters.storeSequencial,
      idconsumidor: consumerId,
      midia: media,
    },
    {
      cache: true,
    }
  );

export const fetchExportCheckIn = (productId, search, exportationType) =>
  axiosPrivate.post(
    "checkin/exportar",
    {
      loja: store.getters.storeSequencial,
      idproduto: productId,
      documento: search,
      exportation: exportationType,
    },
    {
      cache: true,
      responseType: "arraybuffer",
    }
  );

export const fetchPrintTicket = itemId =>
  axiosPrivate.post(
    "loja/pedido_item/getIngresso",
    {
      loja: store.getters.storeSequencial,
      idioma: getLocale(),
      iditem: itemId,
      is_download: true,
    },
    {
      responseType: "arraybuffer",
    }
  );
